export default __webpack_public_path__ + "static/media/steps-desktop-en.590c3c25.svg";